// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"231":"2f2dfe6e0a137053adac","245":"ebe1095bef40ea3fb41b","453":"ee15d8bfce22ee730852","640":"c901fca9c0c31bbf1903","739":"7ac4a1b644160c156813"}[chunkId] + ".js";
};